import AboutSvg1 from "@/public/svgs/about-page/about-svg-1.svg";
import AboutSvg2 from "@/public/svgs/about-page/about-svg-2.svg";
import AboutSvg3 from "@/public/svgs/about-page/about-svg-3.svg";
import AboutSvg4 from "@/public/svgs/about-page/about-svg-4.svg";
import AboutSvg5 from "@/public/svgs/about-page/about-svg-5.svg";
import AboutSvg6 from "@/public/svgs/about-page/about-svg-6.svg";

import AboutStroke1 from "@/public/svgs/about-page/about-stroke-1.svg";
import AboutStroke2 from "@/public/svgs/about-page/about-stroke-2.svg";
import AboutStroke5 from "@/public/svgs/about-page/about-stroke-5.svg";
import AboutStroke6 from "@/public/svgs/about-page/about-stroke-6.svg";
import AboutStroke7 from "@/public/svgs/about-page/about-stroke-7.svg";

/* --------------------------------- */
/* ------------- STORY ------------- */
/* --------------------------------- */
export const OUR_STORY = [
  {
    id: crypto.randomUUID(),
    title: "A Food Truck Dream",
    description:
      "It all began with a food truck flipping burgers on a sunny beach in Dubai. Little did we know that a simple venture would plant the seed for a market revolution.",
    year: 2016,
    icon: <AboutSvg1 />,
    stroke: <AboutStroke1 />,
  },
  {
    id: crypto.randomUUID(),
    title: "Bespoke Trailers Is Born",
    description:
      "As the food truck scene exploded, so did the demand. From one trailer to 20, Bespoke Trailers rapidly became the go-to supplier. Beaches, parks, and drive-throughs all sought our custom solutions. The journey had just begun.",
    year: 2017,
    icon: <AboutSvg2 />,
    stroke: <AboutStroke2 />,
  },
  {
    id: crypto.randomUUID(),
    title: "Enter Bespoke Modular Solutions",
    description:
      "As modular building began reshaping industries, so did we. Our founders, driven by hospitality and service expertise, saw an opportunity. Bespoke Modular Solutions was born to meet the rising need for innovative, modular builds.",
    year: 2020,
    icon: <AboutSvg3 />,
    stroke: <AboutStroke7 />,
  },
  {
    id: crypto.randomUUID(),
    stroke: <AboutStroke6 />,
  },
  {
    id: crypto.randomUUID(),
    title: "Completing The Puzzle",
    description:
      "As demand grew, we turned our sights on becoming a full turnkey operation. Enter Bespoke Joinery Manufacturing—the final piece in our modular puzzle, ensuring that every aspect of design and build could be handled seamlessly.",
    year: 2022,
    icon: <AboutSvg5 />,
    stroke: <AboutStroke5 />,
  },
  {
    id: crypto.randomUUID(),
    title: "A Design Revolution",
    description:
      "Creativity and customization took centre stage. We launched the Bespoke Design Studio, not just to supply in-house services, but to challenge the norms of modular design. Our aim? To deliver tailored, cutting-edge solutions to our clients.",
    year: 2021,
    icon: <AboutSvg4 />,
  },
  {
    id: crypto.randomUUID(),
    title: "A 7,000sqm Modular Powerhouse",
    description:
      "Today, our 7,000sqm facility offers everything in-house, from concept to completion. Whether it’s design, build, fit-outs, or carpentry, we are your ultimate Bespoke Modular Solution to all your manufacturing problems!",
    year: 2024,
    icon: <AboutSvg6 />,
  },
];
